import { gql } from '@apollo/client';
import { useMutation } from '@apollo/client';

const START_INGESTION_MUTATION = gql`
  mutation ditStartIngestion($eventId: ID!) {
    ditStartIngestion(eventId: $eventId)
  }
`;

export const useDitStartIngestion = () => {
  const [startIngestion, { data, loading, error }] = useMutation(START_INGESTION_MUTATION);
  return {
    startDitIngestion: async ({ eventId }) => {
      return await startIngestion({
        variables: {
          eventId,
        },
      });
    },
    ingestionStarted: data?.ditStartIngestion,
    loading,
    error,
  };
};
